import { render, staticRenderFns } from "./EditStudySetOverview.vue?vue&type=template&id=44323aa5&scoped=true&"
import script from "./EditStudySetOverview.vue?vue&type=script&lang=js&"
export * from "./EditStudySetOverview.vue?vue&type=script&lang=js&"
import style0 from "./EditStudySetOverview.vue?vue&type=style&index=0&id=44323aa5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44323aa5",
  null
  
)

export default component.exports